import { FileItem } from 'ng2-file-upload';

export function customStoreDevtoolsSerializer(key: string, value: any): any {
    if (value instanceof FileItem) {
        return 'Excluded from serialization';
    } else if (typeof value === 'function') {
        return undefined;
    }
    return value;
}
